import { t } from 'i18next';
import { TableInstance } from 'react-table';
import { PageSizeSelector } from '~components/ui/PageSizeSelector';
import { Pagination } from '~components/ui/Pagination';
import { SsoTableSsoFragment } from './__generated__/SsoTable.graphql';

export function SsoTablePagination({ table }: { table: TableInstance<SsoTableSsoFragment> }) {
  const {
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    gotoPage,
    state: { pageIndex },
    pageCount,
  } = table;

  return (
    <Pagination
      pageCount={pageCount}
      currentPageIndex={pageIndex}
      hasPreviousPage={canPreviousPage}
      hasNextPage={canNextPage}
      goToPage={gotoPage}
      goToPreviousPage={previousPage}
      goToNextPage={nextPage}
    />
  );
}

export function SsoTablePageSizeSelector({
  table,
  sizes,
}: {
  table: TableInstance<SsoTableSsoFragment>;
  sizes?: number[];
}) {
  const {
    state: { pageSize },
    setPageSize,
  } = table;

  return (
    <PageSizeSelector
      label={t('showRowsPerPage')}
      onChange={setPageSize}
      options={sizes}
      value={pageSize}
    />
  );
}
